import React from "react";

export default function TransactionHistoryModal({
  children,
  heading,
  moreWidth
}) {
  return (
    <div className="modal fade" id="TransactionHistoryModal">
      <div className="modal-dialog modal-dialog-centered" style={moreWidth && { maxWidth: '900px' }} role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{heading}</h5>
            <button type="button" className="close" data-dismiss="modal">
              <span>×</span>
            </button>
          </div>

          {children}
        </div>
      </div>
    </div>
  );
}
